<template>
  <div id="mfi_container">
    <div class="mfi_top">
      <img
        v-lazy-load :data-src="'https://s3.amazonaws.com/app.770apps.static/gotit_sqr_logo.jpg'"
        class="mfi_store_icon pointer"
        alt="gotit logo"
      >
      <div v-if="'GOTit'" class="mfi_store_name">
        <template>
          <span class="pointer ssstore_name">{{ 'Create your custom set' }}</span><br>
        </template>
        <img class="mfi_store_avatar" v-lazy-load data-src="/store_icon.jpg" alt="store icon"><span class="pointer ssstore_name">{{
          'GOTit'
        }}</span>
      </div>
    </div>
    <div class="slider">
      <div
        v-if="$store.state.localStorage.currentUser && $store.state.localStorage.currentUser.extra.credit && $store.state.localStorage.currentUser.extra.credit > 0 && getCreditDaysLeft"
        class="mf_user_credit"
      >
        <img v-lazy-load data-src="/special_badge.png" alt="deal badge">
        <div>
          ${{ $store.state.localStorage.currentUser.extra.credit }} Credit<br>
          {{ getCreditDaysLeft }}
        </div>
      </div>
      <swiper ref="mySwiper" :options="swiperOptions" class="swiper">
        <swiper-slide v-for="(image, index) in vfImages" :key="index" v-observe-visibility="visibilityChanged">
          <div v-if="index === 0 && video" @click.stop="showItem()">
            <video-player
              v-once
              ref="video"
              :style="mobileDesign"
              class="video-player-box"
              :options="{
                muted: muted,
                autoplay: true,
                language: 'en',
                sources: [{
                  type: 'video/mp4',
                  src: video
                }],
                poster: 'https://s3.amazonaws.com/app.770apps.static/gotit_sqr_logo.jpg'
              }"
              :playsinline="true"
              :autoplay="true"
              @ended="onVideoEnded"
              @ready="onVideoReady"
            />
            <img
              v-lazy-load :data-src="muted ? '/icons/mute.png' : '/icons/unmute.png'"
              class="mute_icon"
              alt="mute"
              @click.stop="muted = !muted"
            >
            <div class="replay_overlay" :class="{'show': showReplayButton}">
              <img
                v-if="showReplayButton"
                v-lazy-load :data-src="'/icons/replay.png'"
                class="replay_button"
                alt="mute"
                @click.stop="replay()"
              >
            </div>
          </div>
          <template v-else>
            <img v-lazy-load :data-src="image" class="swiper-lazy" alt="item image" @click.stop="showItem()">
          </template>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
      <div v-if="!$device.isMobileOrTablet && vfImages.length > 1" class="buttons_overlay visible">
        <div
          class="prev_button"
          @click.stop="nextImage(-1)"
          @mouseenter.stop="showArrows = true"
          @mouseleave.stop="showArrows = false"
        >
          <img v-lazy-load data-src="/back.png" class="image_button" alt="prev">
        </div>
        <div class="strech" />
        <div
          class="next_button"
          @click.stop="nextImage(1)"
          @mouseenter.stop="showArrows = true"
          @mouseleave.stop="showArrows = false"
        >
          <img v-lazy-load data-src="/back.png" class="image_button" alt="next">
        </div>
      </div>
    </div>
    <div class="mfi_action_buttons">
      <div class="mfi_buy_it pointer ssstore_name create-set-btn" @click.stop="showItem()">
        Create set <span
          class="old_price"
        >$89</span> <span class="sale_price">$65</span>
      </div>
    </div>
    <div class="item_title">
      {{ 'Create Your Custom Set' }}
    </div>
    <div class="mfi_item_description set">
      <ReadMore
        :text="'Pick any pants with any top to match your favorite styles for a spacial price of $65 instead of $89'"
        :max-char="$device.isMobileOrTablet ? 120 : 170"
      />
    </div>
  </div>
</template>

<script>
import {
  // VueFlux,
  // FluxCaption,
  // FluxControls,
  // FluxIndex,
  // FluxPagination,
  BaseTransition
} from 'vue-flux'

import AbstractComponent from './AbstractComponent'
import utils from '~/mixins/utils'
import ReadMore from '~/components/ReadMore'

export default {
  name: 'CreateSetFeedComponent',
  components: {
    ReadMore
    // VueFlux,
    // FluxCaption,
    // FluxControls,
    // FluxIndex,
    // FluxPagination
  },
  extends: AbstractComponent,
  mixins: [
    BaseTransition,
    utils
  ],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: Object,
    // eslint-disable-next-line vue/require-default-prop
    from: Object
  },
  data () {
    return {
      swiperOptions: {
        lazy: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
        // Some Swiper option/callback...
      },
      vfOptions: {
        autoplay: false,
        enableGestures: true,
        autohideTime: this.entity && !this.entity.image2 ? 1500 : 0
      },
      currentImageIndex: 0,
      mainImage: '',
      vfImages: ['https://s3.amazonaws.com/app.770apps.static/gotit_sqr_logo.jpg'],
      mobileDesign: {},
      video: 'https://d2ohi7od1prmvs.cloudfront.net/create_set.mp4',
      isVisible: false,
      muted: true,
      sendIsVisible: false,
      showReplayButton: false,
      vfTransitions: ['slide'],
      saleitPriceRange: null,
      priceRange: null,
      markupType: 'absolute',
      markupValue: 0,
      productMarkupValue: 0,
      productMarkupValueTmp: 0,
      sourceItem: null,
      timeLeft: null,
      player: null
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    getCreditDaysLeft () {
      if (this.timeLeft) {
        if (this.timeLeft.includes('day')) {
          return this.timeLeft
        } else {
          return this.timeLeft + ' Left'
        }
      }
      const daysLeft = parseInt((this.$store.state.localStorage.currentUser.extra.creditValidThru - new Date().getTime()) / (1000 * 60 * 60 * 24) + '')
      let message = ''
      if (!isNaN(daysLeft)) {
        if (daysLeft === 0) {
          message = '1 day left'
        } else if (daysLeft === 1) {
          message = daysLeft + ' day left'
        } else {
          message = daysLeft + ' days left'
        }
      }
      // bobo
      message = '1 Day Left!'
      return message
    },
    reverseComments () {
      return this.entity.comments.slice().reverse()
    },
    getUserName () {
      return this.$store.state.api.buckets.users[this.entity.userId].name
    },
    getStoreName () {
      if (this.$store.state.api.buckets.users[this.sourceItem.userId]) {
        return this.$store.state.api.buckets.users[this.sourceItem.userId].name
      } else {
        return ''
      }
    },
    getUserImage () {
      const user = this.$store.state.api.buckets.users[this.entity.userId]
      return user ? (user.profilePhotoThumbnail || user.image) : 'https://s3.amazonaws.com/app.770apps.images/defult_pic.png'
    },
    hideComments () {
      if (this.componentData.parameters) {
        return this.componentData.parameters.hideComments
      } else {
        return false
      }
    }
  },
  watch: {
    muted (newVal, oldVal) {
      this.player = this.getPlayer()
      if (this.player) {
        this.player.muted(newVal)
      }
    }
  },
  beforeMount () {
    this.bucketName = 'items'
  },
  mounted () {
    if (this.componentData && (!this.componentData.parameters || !this.componentData.parameters.hideComments)) {
      this.$root.$on('refresh-comments', (commentEvent) => {
        if (this.entity.id === commentEvent.itemId) {
          this.refreshComments()
        }
      })
    }
    if (this.entity) {
      this.init()
    }
  },
  methods: {
    replay () {
      this.showReplayButton = false
      this.player = this.getPlayer()
      if (this.player) {
        this.player.play()
      }
    },
    onVideoEnded () {
      this.showReplayButton = true
      this.player = this.getPlayer()
      if (this.player) {
        this.player.pause()
      }
    },
    getPlayer () {
      if (this.$refs.video) {
        return this.$refs.video.player || this.$refs.video[0].player
      }
    },
    onVideoReady () {
      this.player = this.getPlayer()
      if (this.player && this.isVisible) {
        this.player.muted(this.muted)
        this.player.play()
        // this.$store.dispatch('api/itemExecute', {
        //   id: this.stories[this.currentIndex].id, type: 'VIEW_STORY'
        // }).then().catch()
      }
    },
    visibilityChanged (isVisible, entry) {
      this.isVisible = isVisible
      if (this.$refs.video) {
        this.player = this.getPlayer()
        if (this.player && !this.isVisible) {
          this.player.pause()
        } else if (this.player && this.isVisible) {
          this.player.muted(this.muted)
          this.player.play()
          this.showReplayButton = false
          if (!this.sendIsVisible) {
            this.sendIsVisible = true
            this.$store.dispatch('api/sendLogMessage', 'create_set_visible').then().catch()
            this.$store.dispatch('api/trackEvent', {
              eventName: 'create_set_visible',
              params: {
                path: this.$route.path,
                page: 'feed'
              }
            }).then().catch()
          }
        }
      }
    },
    showItemComments () {
      this.$root.$emit('show_item_comments_dialog', { entity: this.entity, type: 'ITEM' })
    },
    onContextMenuClick () {
      this.$root.$emit('show_share_menu', { item: this.entity })
    },
    getCreatedFormated (date) {
      const seconds = Math.floor((new Date() - date) / 1000)

      let interval = seconds / 31536000

      if (interval > 1) {
        return Math.floor(interval) + ' years'
      }
      interval = seconds / 2592000
      if (interval > 1) {
        return Math.floor(interval) + ' months'
      }
      interval = seconds / 86400
      if (interval > 1) {
        return Math.floor(interval) + ' days'
      }
      interval = seconds / 3600
      if (interval > 1) {
        return Math.floor(interval) + 'h'
      }
      interval = seconds / 60
      if (interval > 1) {
        return Math.floor(interval) + 'm'
      }
      return 'Now'
    },
    getUser (userId) {
      return this.$store.state.api.buckets.users[userId]
    },
    nextImage (direction) {
      if (this.currentImageIndex === 0 && direction === -1) {
        this.currentImageIndex = this.vfImages.length - 1
      } else if (this.currentImageIndex === this.vfImages.length - 1 && direction === 1) {
        this.currentImageIndex = 0
      } else {
        this.currentImageIndex += direction
      }

      this.$refs.mySwiper.$swiper.slideTo(this.currentImageIndex, 1000, false)
      // this.mainImage = this.vfImages[this.currentImageIndex]
    },
    showItem () {
      this.$store.dispatch('api/sendLogMessage', 'create_set_click_feed').then().catch()
      this.$store.dispatch('api/trackEvent', {
        eventName: 'create_set_click_feed',
        params: {
          path: this.$route.path,
          page: 'item_page',
          itemId: this.itemId
        }
      }).then().catch()
      const path = '/create-set'
      this.$emit('navigate', path)
    },
    showLikersUsers () {
      this.$root.$emit('show_users_dialog', this.entity, 'LIKERS')
    },
    showGotItUsers () {
      this.$root.$emit('show_users_dialog', this.getItem(this.entity.sourceId), 'GOTTERS')
    },
    showWantItUsers () {
      this.$root.$emit('show_users_dialog', this.entity, 'WANTERS')
    },
    refreshComments () {
      this.entity = this.getItem(this.entityId)
    },
    getItem (itemId) {
      return this.$store.state.api.buckets.items[itemId]
    },
    init () {
      this.sourceItem = this.getItem(this.entity.sourceId) || this.entity
      let width = Math.min(screen.width, 558)
      width = width + 'x' + width
      if (this.entity.image) {
        this.vfImages.push(this.entity.image.replace('https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)', 'https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)/fit-in/' + width))
      }
      if (this.entity.image2) {
        this.vfImages.push(this.entity.image2.replace('https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)', 'https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)/fit-in/' + width))
      }
      if (this.entity.image3) {
        this.vfImages.push(this.entity.image3.replace('https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)', 'https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)/fit-in/' + width))
      }
      if (this.entity.image4) {
        this.vfImages.push(this.entity.image4.replace('https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)', 'https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)/fit-in/' + width))
      }
      if (this.entity.image5) {
        this.vfImages.push(this.entity.image5.replace('https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)', 'https://d3q2desntvz2qi.cloudfront.net/filters:format(jpeg)/fit-in/' + width))
        // this.vfImages.push(this.entity.image5)
      }
      this.mainImage = this.entity.image
      if (this.sourceItem.saleitPriceRange) {
        const strings = this.sourceItem.saleitPriceRange
          .replace('$', '')
          .replace('$', '')
          .split(' - ')
        this.saleitPriceRange = new Array(2)
        this.saleitPriceRange[0] = this.getPriceBeforeMarkup(parseInt(strings[0], 10))
        this.saleitPriceRange[1] = this.getPriceBeforeMarkup(parseInt(strings[1], 10))
      }

      if (this.sourceItem.priceRange) {
        const strings = this.sourceItem.priceRange
          .replace('$', '')
          .replace('$', '')
          .split(' - ')
        this.priceRange = new Array(2)
        this.priceRange[0] = this.getPriceBeforeMarkup(parseInt(strings[0], 10))
        this.priceRange[1] = this.getPriceBeforeMarkup(parseInt(strings[1], 10))
      }

      if (this.sourceItem.markupValue > -1) {
        this.productMarkupValue = this.sourceItem.markupValue
      } else {
        this.productMarkupValue = this.sourceItem.defaultMarkupValue
      }
      this.productMarkupValue = this.productMarkupValue || 0
      this.productMarkupValueTmp = this.productMarkupValue
      this.startCreditTimer()
      this.$root.$on('credit_time_left', (timeLeft) => {
        this.timeLeft = timeLeft
      })
    },
    startCreditTimer () {
      if (this.$store.state.localStorage.currentUser && this.$store.state.localStorage.currentUser.extra.credit) {
        if (this.$store.state.localStorage.firstVisit) {
          const date1 = new Date(this.$store.state.localStorage.firstVisit)
          const currentDate = new Date()
          const diffTime = Math.abs(date1.valueOf() - currentDate.valueOf())
          const days = diffTime / (24 * 60 * 60 * 1000)
          if (days >= 1) {
            let timeLeft
            let timeLeftJson
            const activationCreditActive = (this.$store.state.api.globals.creditTimer || this.$store.state.localStorage.activationTimerTimestamp) && this.$store.state.localStorage.timerShowedupInCart
            if (activationCreditActive) {
              timeLeft = this.getDiff(parseInt(this.$store.state.api.globals.creditTimer || this.$store.state.localStorage.currentUser.extra.creditValidThru))
              timeLeftJson = this.getDiffJson(parseInt(this.$store.state.api.globals.creditTimer || this.$store.state.localStorage.currentUser.extra.creditValidThru))
            } else {
              timeLeft = this.getDiff(parseInt(this.$store.state.localStorage.currentUser.extra.creditValidThru))
              timeLeftJson = this.getDiffJson(parseInt(this.$store.state.localStorage.currentUser.extra.creditValidThru))
            }
            if (timeLeftJson.days === 1) {
              timeLeft = 'Last day'
            } else if (timeLeftJson.days > 1) {
              timeLeft = timeLeftJson.days + ' days left'
            }
            timeLeftJson.creditValidThru = this.$store.state.localStorage.currentUser.extra.creditValidThru
            this.timeLeft = timeLeft
          }
        }
      }
    },
    getDiffJson (date, dateToCompare) {
      const date1 = new Date(date)
      const currentDate = dateToCompare || new Date()
      const diffTime = Math.abs(date1.valueOf() - currentDate.valueOf())
      const days = diffTime / (24 * 60 * 60 * 1000)
      let hours = (days % 1) * 24 + (Math.floor(days) * 24)
      let minutes = (hours % 1) * 60
      let secs = (minutes % 1) * 60
      hours = Math.floor(hours)
      minutes = Math.floor(minutes)
      secs = Math.floor(secs)
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      return { days: Math.floor(days), hours, minutes, secs }
    },
    getDiff (date, dateToCompare) {
      const date1 = new Date(date)
      const currentDate = dateToCompare || new Date()
      const diffTime = Math.abs(date1.valueOf() - currentDate.valueOf())
      const days = diffTime / (24 * 60 * 60 * 1000)
      let hours = (days % 1) * 24 + (Math.floor(days) * 24)
      let minutes = (hours % 1) * 60
      let secs = (minutes % 1) * 60
      hours = Math.floor(hours)
      minutes = Math.floor(minutes)
      secs = Math.floor(secs)
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (secs < 10) {
        secs = '0' + secs
      }
      return `${hours}:${minutes}:${secs}`
    },
    onBuyItClick () {
      this.$root.$emit('buy_it', this.entity)
    },
    onWantItClick () {
      let wantit
      const params = {
        id: this.entity.id,
        type: 'WANTIT'
      }
      let firebaseAction = 'item_wantit'
      if (!this.entity.extra) {
        wantit = 'true'
      } else if (this.entity.extra && this.entity.extra.isWantit === 'true') {
        wantit = 'false'
        firebaseAction = 'item_unwantit'
      } else {
        wantit = 'true'
      }
      this.entity.extra.isWantit = wantit
      params.typeParam = wantit
      this.entity.extra = JSON.stringify(this.entity.extra)
      this.$store.dispatch('api/itemExecute', params)
        .then((entity) => {
          this.entity = entity
          this.$store.dispatch('api/trackEvent', {
            eventName: firebaseAction,
            params: {
              userId: this.$store.state.localStorage.currentUser.id,
              path: this.$route.path,
              itemId: this.entity.id
            }
          }).then().catch()
        })
        .catch()
    },
    getSaleitPriceRange () {
      if (this.saleitPriceRange) {
        const min = this.getItemFinalPrice(this.saleitPriceRange[0])
        const max = this.getItemFinalPrice(this.saleitPriceRange[1])
        return min + ' - ' + max
      } else {
        return ''
      }
    },
    getItemFinalPrice (itemPrice) {
      itemPrice = parseInt(itemPrice)
      if (this.sourceItem) {
        if (this.markupValue === 0) {
          itemPrice = itemPrice + (this.sourceItem.defaultMarkupValue || 0)
        } else {
          switch (this.markupType) {
            case 'absolute':
              if (this.markupValue !== -1) {
                itemPrice += this.markupValue
              } else {
                itemPrice += (this.sourceItem.defaultMarkupValue || 0)
              }
              break
            case 'custom':
              if (this.productMarkupValueTmp !== -1) {
                itemPrice += this.productMarkupValueTmp
              } else {
                itemPrice += (this.sourceItem.defaultMarkupValue || 0)
              }
              break
          }
        }
        return '$' + Math.round(itemPrice)
      } else {
        return '$0'
      }
    },
    getPriceBeforeMarkup (price) {
      const markupType = this.sourceItem.markupType || this.markupType
      if (this.markupValue === 0 || this.markupValue === -1) {
        price = price - (this.sourceItem.defaultMarkupValue || 0)
      } else {
        switch (markupType) {
          case 'absolute':
            price = price - (this.markupValue || 0)
            break
          case 'custom':
            price = price - (this.productMarkupValueTmp || 0)
            break
        }
      }
      return Math.round(price)
    },
    getPriceRange () {
      if (this.priceRange) {
        const min = this.getItemFinalPrice(this.priceRange[0])
        const max = this.getItemFinalPrice(this.priceRange[1])
        return min + ' - ' + max
      } else {
        return ''
      }
    }
  }
}
</script>
<style>

.mfi_action_buttons {
  display: flex;
}

.mfi_action_buttons div {
  margin: 1em;
}

.mobile_design .mfi_action_buttons div {
  margin: 0.5em;
}

#mfi_want_it {
  flex-grow: 1.47 !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.mobile_design #mfi_want_it {
  height: 38px;
  margin-top: 0.57em;
}

#mfi_buy_it {
  flex-grow: 1;
  margin-left: unset;
  border: 1px solid red !important;
}

.mfi_action_buttons > div {
  border: 1px solid black;
  border-radius: 5px;
}

.flux-button.play.top, .flux-index {
  display: none !important;
}

.clock {
  filter: invert(35%) sepia(100%) saturate(707%) hue-rotate(316deg) brightness(96%) contrast(94%);
  width: 24px;
  height: 24px;
}

.clock, .mfi_created_at {
  /*margin-right: 0.5em;*/
}

.mobile_design .clock {
  font-size: 15px !important;
  height: 15px !important;
  width: 15px !important;
  line-height: 15px !important;
}

.item_image {
  width: 560px;
  height: 560px;
}

.mobile_design .item_image {
  width: unset;
  height: unset;
  padding-top: 100%
}

#mfi_container {
  width: 560px;
  text-align: center;
  border: 1px solid #efefef;
  border-radius: 3px;
  background: white;
  margin-top: 1.5em;
}

.mobile_design #mfi_container {
  width: 100%;
  margin-top: 0.4em;
}

.mfi_top {
  display: flex;
  align-items: center;
  padding: 0.5em;
  border-bottom: 1px solid #efefef;
}

.mobile_design .mfi_top {
  border-bottom: unset;
}

.mfi_top .md-icon {
  justify-self: right;
}

.mfi_store_name {
  flex-grow: 1;
  text-align: left;
  margin-left: 0.7em;
}

.mfi_store_icon {
  width: 39px !important;
  height: 39px !important;
  border-radius: 50%;
}

.mfi_store_avatar {
  width: 17px;
  height: 17px;
  margin-right: 0.5em;
}

.mySlides {
  display: none
}

/* Slideshow container */
.slideshow-container {
  max-width: 1000px;
  position: relative;
  margin: auto;
}

/* Next & previous buttons */
.prev, .next {
  cursor: pointer;
  /*position: absolute;*/
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -22px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover, .next:hover {
  /*background-color: rgba(0, 0, 0, 0.8);*/
}

button:hover > svg polyline {
  stroke: #c6c2c2 !important;
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

/* Number text (1/3 etc) */
.numbertext {
  color: #f2f2f2;
  font-size: 12px;
  padding: 8px 12px;
  position: absolute;
  top: 0;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active, .dot:hover {
  background-color: #717171;
}

/* Fading animation */
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}

@-webkit-keyframes fade {
  from {
    opacity: .4
  }
  to {
    opacity: 1
  }
}

@keyframes fade {
  from {
    opacity: .4
  }
  to {
    opacity: 1
  }
}

/* On smaller screens, decrease text size */
@media only screen and (max-width: 300px) {
  .prev, .next, .text {
    font-size: 11px
  }
}

.pagination-item.active {
  background-color: red !important;
}

.item_title {
  font-family: 'Arial Bold', 'Arial', serif;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 18px;
  text-align: left;
  margin-left: 1em;
}

.mfi_item_description {
  font-size: 16px;
  color: #666666;
  line-height: 22px;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
}

.mfi_item_description.set {
  margin-bottom: 1em;
}

#readmore {
  font-family: 'Arial Bold', 'Arial', serif;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  color: black;
  line-height: 36px;
  text-align: left;
}

.sale_price {
  color: red;
  font-weight: bold;
}

.v_selected {
  height: 20px !important;
  margin-right: 0.5em;
}

.slider {
  overflow: hidden;
  position: relative;
}

.mf_user_credit img {
  width: 170px;
  height: 40px;
}

.mobile_design .mf_user_credit img {
  width: 120px;
}

.mf_user_credit {
  position: absolute;
  z-index: 2;
  margin-top: 3em;
  display: flex;
}

.mf_user_credit div {
  position: absolute !important;
  display: inline-block !important;
  margin-top: 0.3em;
  margin-left: 1em;
  font-size: 14px;
  line-height: 14px;
  color: white;
  font-weight: bold;
  z-index: 3;
  left: 20px;
}

.mobile_design .mf_user_credit div {
  font-size: 14px;
  line-height: 13px;
  left: -0.6em;
  margin-top: 0.5em;
}

#slides article {
  width: 25%;
  float: left;
}

input[type="radio"] {
  display: none;
}

label {
  /*background: #CCC;*/
  display: inline-block;
  cursor: pointer;
  width: 10px;
  height: 10px;
  border-radius: 5px;
}

#slide1:checked ~ label[for="slide1"],
#slide2:checked ~ label[for="slide2"],
#slide3:checked ~ label[for="slide3"],
#slide4:checked ~ label[for="slide4"] {
  background: #333;
}

.swiper {
  height: 560px;
}

.mobile_design .swiper {
  height: unset;
  min-height: 350px;
}

#mfi_container .plyr__controls {
  /*display: none;*/
  bottom: 2em;
}

.mobile_design .ssstore_name, .mobile_design .mfi_created_at, .mobile_design .mfi_statistics {
  font-size: 16px;
}

.replay_overlay {
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  -webkit-transition: background 0.5s; /* For Safari 3.0 to 6.0 */
  transition: background 0.5s; /* For modern browsers */
}

.replay_overlay.show {
  background-color: rgba(0, 0, 0, 0.37);
}

.replay_button {
  width: 30px;
  position: absolute;
  z-index: 32;
  top: calc(50% - 15px);
  right: calc(50% - 15px);
  filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(234deg) brightness(103%) contrast(100%);
}

.mute_icon {
  width: 30px;
  position: absolute;
  z-index: 32;
  top: 1em;
  right: 1em;
  filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(234deg) brightness(103%) contrast(100%);
}

.create-set-btn {
  padding: 0.5em;
  width: 100%;
}
</style>
